// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface DataType {
  approve_status: number
  approve_by: string | null
  customer_name: string
  location_name: string
  memo: string
  qty_return: number
  return_id: number
  return_status: number
  total: number
  transaction_date: string
  trx_code: string
  trx_invoice_code: string
  approve_by_name: string
}

export function useList(): {
  changeStatus: (value: string) => void
  data: DataType[]
  isLoading: boolean
  returnStatus: string
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<DataType[]>([])
  const [isLoading, setLoading] = useState<boolean>(false)
  const [returnStatus, setReturnStatus] = useState<string>("")

  useEffect(() => {
    setLoading(true)

    api.post(
      `/return/getdata_by_return_status?${returnStatus ? `return_status=${returnStatus}` : ""}`
    ).then((res: SuccessFetch<{
      payload: DataType[]
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData([])
      setLoading(false)
    }

    // eslint-disable-next-line
  }, [returnStatus])

  // Functions
  const changeStatus = (value: string) => {
    setReturnStatus(value)
  }

  return { data, isLoading, returnStatus, changeStatus }
}